import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '', // 指标表id
    orgId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpi.setMyProjKpiOrgId, {
        id,
        orgId,
    }, options);
    if (error) return { error, status };
    return content || { };
};
